var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutletDetailsOutletForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.341,
    height: 15.162,
    viewBox: "0 0 17.341 15.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63264",
    "data-name": "Group 63264",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221848",
    "data-name": "Path 221848",
    d: "M5.545,28A.545.545,0,0,0,5,28.545v5.992A2.723,2.723,0,0,0,7.724,37.26h9.26a2.724,2.724,0,0,0,2.724-2.724V28.545A.545.545,0,0,0,19.162,28Z",
    transform: "translate(-4.183 -23.098)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63264-2",
    "data-name": "Group 63264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221851",
    "data-name": "Path 221851",
    d: "M2.836,2.4A.545.545,0,0,1,3.362,2H16.979a.545.545,0,0,1,.525.4l.817,3a.544.544,0,0,1,.019.143,2.451,2.451,0,0,1-4.358,1.541,2.451,2.451,0,0,1-3.813,0,2.451,2.451,0,0,1-3.813,0A2.451,2.451,0,0,1,2,5.541.545.545,0,0,1,2.019,5.4Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30616",
    "data-name": "Rectangle 30616",
    width: 8.186,
    height: 1.488,
    rx: 0.744,
    transform: "translate(4.116 9.532)",
    fill: "none",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletDetailsOutletForm);
export default __webpack_public_path__ + "static/media/outletDetailsOutletForm.fbffa85a41abe76974e69c6f662fafd0.svg";
export { ForwardRef as ReactComponent };